import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Stack,
    Typography,
    useMediaQuery,

} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
// project imports
import useScriptRef from '../../Hooks/useScriptRef';

import { useNavigate,useLocation,useParams } from 'react-router-dom';
import AuthState from '../../Hooks/Authinctication.state';
// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AuthCardWrapper from 'Component/AuthCardWrapper';
import AuthWrapper1 from 'Component/AuthWrapper1';


import { ToastContainer } from 'react-toastify';
const NewPassword = ({ ...others }) => {
    const theme = useTheme();
    const scriptedRef = useScriptRef();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const {token} = useParams()
    const [checked, setChecked] = useState(true);
    const navigate = useNavigate()
    const { formBusy, NewPassword } = AuthState()
    console.log(token)
    const googleHandler = async () => {
        console.error('Login');
    };

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <ToastContainer />
            <AuthWrapper1>
                <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }} className='login-background' >
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                                <AuthCardWrapper>
                                    <Grid container spacing={2} alignItems="center" justifyContent="center">

                                        <Grid item xs={12}>
                                            <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                                                <Grid item>
                                                    <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                        <Typography color={"#92c323"} gutterBottom variant={matchDownSM ? 'h5' : 'h4'}>
                                                            New Password
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container direction="column" justifyContent="center" spacing={2}>

                                                <Grid item xs={12} container alignItems="center" justifyContent="center">
                                                    <Box sx={{ mb: 2 }}>
                                                        <Typography variant="subtitle1"> Enter your new password </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>

                                            <Formik
                                                initialValues={{
                                                  
                                                    password: '',
                                                    confirm_password:"",
                                                    submit: null
                                                }}
                                                validationSchema={Yup.object().shape({
                                                    password: Yup.string().max(255).required('Password is required'),
                                                    confirm_password:Yup.string().required("Confirm password is required").oneOf([Yup.ref("password"),null],"Password must match")

                                                })}
                                                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                                                    try {
                                                        console.log("dat...", values)
                                                        const data = {
                                                          
                                                            password: values.password
                                                        }
                                                        NewPassword(token, data)
                                                        if (scriptedRef.current) {
                                                            setStatus({ success: true });
                                                            setSubmitting(false);
                                                            const data = {
                                                               
                                                                password: values.password
                                                            }
                                                            NewPassword(token,data)

                                                        }
                                                    } catch (err) {
                                                        console.error(err);
                                                        if (scriptedRef.current) {
                                                            setStatus({ success: false });
                                                            setErrors({ submit: err.message });
                                                            setSubmitting(false);

                                                        }
                                                    }
                                                }}
                                            >
                                                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, submitForm, touched, values }) => (
                                                    <form noValidate  {...others}>
                                                        <FormControl fullWidth error={Boolean(touched.password && errors.password)} sx={{ ...theme.typography.customInput, mt: 3 }}>
                                                            <InputLabel htmlFor="outlined-adornment-password-login">Password</InputLabel>
                                                            <OutlinedInput
                                                                id="outlined-adornment-password-login"
                                                                type={showPassword ? 'text' : 'password'}
                                                                value={values.password}

                                                                name="password"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={handleClickShowPassword}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                            edge="end"
                                                                            size="large"
                                                                        >
                                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label="Password"
                                                                inputProps={{}}
                                                            />
                                                            {touched.password && errors.password && (
                                                                <FormHelperText error id="standard-weight-helper-text-password-login">
                                                                    {errors.password}
                                                                </FormHelperText>
                                                            )}
                                                        </FormControl>
                                                        <FormControl fullWidth error={Boolean(touched.confirm_password && errors.confirm_password)} sx={{ ...theme.typography.customInput, mt: 3 }}>
                                                            <InputLabel htmlFor="outlined-adornment-password-login">Confirm Password</InputLabel>
                                                            <OutlinedInput
                                                                id="outlined-adornment-password-login"
                                                                type={showPassword ? 'text' : 'password'}
                                                                value={values.confirm_password}

                                                                name="confirm_password"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="toggle password visibility"
                                                                            onClick={handleClickShowPassword}
                                                                            onMouseDown={handleMouseDownPassword}
                                                                            edge="end"
                                                                            size="large"
                                                                        >
                                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                label="Confirm Password"
                                                                inputProps={{}}
                                                            />
                                                            {touched.confirm_password && errors.confirm_password && (
                                                                <FormHelperText error id="standard-weight-helper-text-password-login">
                                                                    {errors.confirm_password}
                                                                </FormHelperText>
                                                            )}
                                                        </FormControl>

                                                        {errors.submit && (
                                                            <Box sx={{ mt: 3 }}>
                                                                <FormHelperText error>{errors.submit}</FormHelperText>
                                                            </Box>
                                                        )}


                                                      

                                                        <Box sx={{ mt: 2 }}>

                                                            <Button onClick={submitForm} sx={{backgroundColor:"#92c323",'&:hover':{backgroundColor:"#76a521"}}} disableElevation disabled={formBusy} fullWidth size="large" variant="contained" color="secondary">
                                                                {formBusy ? "Please wait...." : "Submit"}
                                                            </Button>

                                                        </Box>
                                                    </form>
                                                )}
                                            </Formik>
                                        </Grid>
                                    </Grid>
                                </AuthCardWrapper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AuthWrapper1>
        </>
    );
};

export default NewPassword;
